module.exports = __webpack_public_path__ + "static/media/donbosco18.7c2cf0b0.jpg";